import { Injectable } from '@angular/core';
import { HelperService, DialogService, LanguageService, S3Service } from 'src/app/services';
import { MAINTENANCE_COMPANY_FOLDERNAME } from 'src/app/utils/constant';
import { environment } from '../../../../environments/environment';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from '../../../utils/constant/paths';
import * as _ from "lodash";

@Injectable({
  providedIn: 'root'
})
export class CompanyMaintenanceService {
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  constructor(
    private s3: S3Service,
    private http: HttpService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    ) { }
    
  getList(data?: any) {
    return this.http.post(Path.COMPANY.GET_LIST, data);
  }

  getListMapping(data?: any) {
    return this.http.post(Path.COMPANY.GET_LIST_WEB_USER_COMPANY_MAPPING, data);
  }
  
  getDetail(params?: any) {
    return this.http.get(Path.COMPANY.GET_DETAIL, params);
  }
  
  insert(data?: any) {
    return this.http.post(Path.COMPANY.INSERT, data);
  }

  getIndustries(data?: any) {
    return this.http.post(Path.INDUSTRY.GET_LIST, data);
  }

  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_COMPANY_MAINTENACE, data);
  }

  chooseFile(ev, inputElement, formGroup) {
    let fileToUpload;
    if ((ev.target.files[0].type == 'image/jpeg') || (ev.target.files[0].type == 'image/gif') || (ev.target.files[0].type == 'image/png')) {
      fileToUpload = _.get(ev.target, 'files[0]');
      console.log(fileToUpload);
    } else {
      this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INVALID_FILE_FORMAT", { format: '.jpg, .png, or .gif' }));
      fileToUpload = null;
      inputElement.value = "";
      return;
    }

    if(_.get(fileToUpload, 'size') > 2000000) {
      this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INVALID_FILE_SIZE", {size: 2}));
      fileToUpload = null;
      inputElement.value = "";
      return;
    }

    let loadingDialogRef = this.dialogService.loading();

    let tempObj = {
      folderName: MAINTENANCE_COMPANY_FOLDERNAME,
      file: fileToUpload,
    }
    
    this.s3.upload(tempObj, (err, res) => {
      if (err) {
        if(environment.showLogs) {
          console.log("Error uploading: ", err);
        }
        this.dialogService.confirm({
          title: "UPLOAD FAILED",
          message: this.languageService.getTranslation("MSG_UPLOADING_FAILED", {}),
          button: "Close",
          hasCancel: false
        });
        //this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_UPLOADING_FAILED", {}));
        loadingDialogRef.close();
        return err;
      }
      else if (res) {
        if(environment.showLogs) {
          console.log(res);
        }
        
        formGroup.get('image_original_uploaded_filename').setValue(_.get(fileToUpload, 'name'));
        formGroup.get('image_url').setValue(MAINTENANCE_COMPANY_FOLDERNAME + "/" +  res);
        loadingDialogRef.close();
        this.dialogService.confirm({
          title: this.languageService.getTranslation("MSG_UPLOADING_SUCCESS", {}),
          message: this.languageService.getTranslation("MSG_SUCCESS_EMAIL_UPLOAD", {}),
          button: "Close",
          hasCancel: false
        });
        //this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_UPLOADING_SUCCESS", {}));
      }
    })
  }
}